<template>
<v-dialog id="faqs-dialog" v-model="open" fullscreen hide-overlay transition="dialog-bottom-transition">
  <v-card max-height="100%" color="#D6B682" class="pa-3">

    <v-toolbar flat color="black">
      <v-toolbar-title class="bebas fdi-beige--text">Frequently Asked Questions</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn color="#D6B682" flat left @click="closeFAQS">close<v-icon>close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-list subheader color="#D6B682" class="mt-3 fdi-beige">

      <v-subheader class="title black--text bebas">General</v-subheader>

      <v-list-group no-action>
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title class="pl-3 bebas">Tipping:</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-card class="px-3 fdi-beige prestige-font">
          <v-card-text>Your food is all paid for, but we recommend leaving a tip of $2-3/person/sit-down restaurant for good service (there will be 3). We'd actually prefer to work tips into the ticket price, but keeping tips in your control better assures good service and keeps ticket prices lower. Unless you experience exceptional service or are very generous, each person will spend less than $10 on tips during the tour. Of course, if you choose to buy drinks, you should also tip on those as usual.
          </v-card-text>
        </v-card>
      </v-list-group>
    </v-list>

    <v-list subheader color="#D6B682" class="fdi-beige">

      <v-subheader class="title black--text bebas">Pace Yourself</v-subheader>
      <v-list-group no-action>
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title class="pl-3 bebas">Time:</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-card class="px-3 fdi-beige prestige-font">
          <v-card-text>Each venue is expecting you within a certain time-window, so try to spend only about 30 min. to one hour at each location.</v-card-text>
        </v-card>
      </v-list-group>
      <v-list-group no-action>
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title class="pl-3 bebas">Appetite:</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-card class="px-3 fdi-beige prestige-font">
          <v-card-text>The type of Restaurant icon on the Top Navigation panel (with 6 icons) will give you insight into what kind of food you should expect at this stop.  So it is important to plan ahead and not order too much food at early stops, because you have delicious and savory meals awaiting<br><br><img :src="savoryActive" height="35"/><br>Expect a Savory Dish<br><br><img :src="sweetActive" height="35"/><br>Expect a Sweet Dish<br><br><img :src="noneActive" height="35"/><br>No food expected<br></v-card-text>
        </v-card>
      </v-list-group>
    </v-list>
    <v-list subheader color="#D6B682" class="fdi-beige">

      <v-subheader class="title black--text bebas">Technical Issues & App Questions</v-subheader>
      <v-list-group no-action>
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title class="pl-3 bebas">WIFI:</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-card class="px-3 fdi-beige prestige-font">
          <v-card-text>This web-app tour-guide relies at times on connecting to WiFi at our partner locations,
            and/or data connection from your device's service provider. If you are experiencing connection
            issues, first try:
            <v-spacer></v-spacer>
            <ul>
              <li>Connecting to WiFi if available in your location.</li>
              <li>Refreshing the page with the Refresh button in the <span class=" subheading bebas">Troubleshooting</span> menu. </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-list-group>
      <v-list-group no-action>
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title class="pl-3 bebas">Live Support:</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-card class="px-3 fdi-beige prestige-font">
          <v-card-text>There will be no human tour-guide but if you need assistance, use the "Live Support" feature in the Help menu to contact us directly. <br> <br>Also, we do our best to regularly check that all props/puzzles/supplies are stocked and in good condition. If you experience any issues, please contact us right away so we can resolve them.</v-card-text>
        </v-card>
      </v-list-group>
    </v-list>
  </v-card>
</v-dialog>
</template>

<script>
import backButton from "@/assets/buttons/back-blk.png";
import savoryActive from "@/assets/restaurantIcons/active/savory_active.png";
import sweetActive from "@/assets/restaurantIcons/active/sweet_active.png";
import noneActive from "@/assets/restaurantIcons/active/store_active.png";
export default {
  name: "faqs-dialog",
  props: {
    open: {
      type: Boolean
    }
  },
  data() {
    return {
      dialog: true,
      questions: [],
      backButton: backButton,
      savoryActive,
      sweetActive,
      noneActive
    };
  },
  methods: {
    closeFAQS() {
      this.$store.dispatch("closeFAQS");
    }
  },
  computed: {
    faqDialog() {
      return this.$store.getters.faqDialog;
    }
  }
};
</script>

<style>
#faqs {
  font-family: "1942";
  font-weight: "bold";
}

.bebas {
  font-family: "BebasNeue-Regular" !important;
}

.prestige-font {
  font-family: "PrestigeElite-STD";
}

.fdi-beige--text {
  color: #d6b682;
}

.fdi-beige {
  background-color: #d6b682 !important;
}
.fdi-red {
  background-color: #ae250a !important;
}

.faq-container {
  height: 500px;
  background-color: white;
}
</style>
